import React from "react";
import styles from "./index.module.scss";
import open from "../../img/open.png";
import close from "../../img/close.png";
import moment from "moment";
import "moment/locale/zh-cn";
import { isTrue } from "service/service";
import classNames from "classnames";
import { ReceiveListItem } from "service/notice";

interface ListItemProps {
    active: boolean;
    data: ReceiveListItem;
    onClick: () => void;
}

const NoticeItem = ({ active, data, onClick }: ListItemProps) => {
    return (
        <div className={styles.root}>
            <div className={styles.container} onClick={onClick}>
                <div
                    className={classNames(styles.info, {
                        [styles.opened]: isTrue(data.readStatus)
                    })}>
                    <span
                        className={classNames(styles.time, {
                            [styles.opened]: isTrue(data.readStatus)
                        })}>
                        {moment(data.time).format("MM-DD HH:mm:ss")}
                    </span>
                    <div
                        className={classNames(styles.sender, {
                            [styles.opened]: isTrue(data.readStatus)
                        })}>
                        发件人：{data.teacherName}
                    </div>
                </div>

                <img
                    src={isTrue(data.readStatus) ? open : close}
                    className={styles.img}
                />

                <div>
                    <div
                        className={classNames(styles.title, {
                            [styles.opened]: isTrue(data.readStatus)
                        })}>
                        {data.title}
                    </div>
                </div>
            </div>

            <div
                className={styles.target}
                style={{ display: active ? "block" : "none" }}>
                通知内容：
                <br />
                <div
                    className={styles.body}
                    style={{ display: active ? "inline-block" : "none" }}
                    dangerouslySetInnerHTML={{ __html: data.content }}
                />
            </div>
        </div>
    );
};
export default NoticeItem;
